import { FC, useRef, useEffect, useState } from 'react';
// Models
import IAnswer from 'models/Answer';
// Component
import { Button } from 'components/Buttons';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuestionAnswerPicked, selectIsAnyAnswerCorrect } from 'store/player/playerSelectors';
import { setQuestionAnswerPicked, setQuestionStart } from 'store/player/playerSlice';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';
import QuizTypes from 'types/QuizTypes';

type Props = {
  answer: IAnswer;
  onClick: (answer:{ ref:string, title:string, correct:boolean }) => void;
  disabled?: boolean;
};

const AnswerButton:FC<Props> = ({
  // Props
  answer, onClick, disabled = false,
}) => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const questionAnswerPicked:boolean = useAppSelector(selectQuestionAnswerPicked);
  const isAnyAnswerCorrect:boolean = useAppSelector(selectIsAnyAnswerCorrect);
  const quiz:IQuiz = useAppSelector(selectQuiz);

  const { highlightCorrectAnswer } = quiz;
  
  const timeout = useRef<any>(null);
  const timeoutTime = 500;

  const [ clicked, setClicked ] = useState(false);

  useEffect(() => {
    return () => {
      if ( timeout.current ) clearTimeout(timeout.current);
    }
    // eslint-disable-next-line
  }, []);

  const handleClick = () => {
    if(clicked) return;
    const { ref, title, correct } = answer;

    dispatch(setQuestionStart(false));

    timeout.current = setTimeout(() => {
      onClick({ ref, title, correct });
      dispatch(setQuestionAnswerPicked(true));
    }, timeoutTime);

    setClicked(true);
  }

  const isScoringQuiz = quiz.type === QuizTypes.Scoring;
  const isPredictionQuiz = quiz.type === QuizTypes.Prediction;

  return (
    <Button
      className={`
        ${questionAnswerPicked ? 'pointer-events-none' : ''}
        ${questionAnswerPicked && clicked && isScoringQuiz
          ? isAnyAnswerCorrect
            ? 'bg-none hover:bg-none bg-green-500 text-white '
            : answer.correct
              ? 'bg-none hover:bg-none bg-green-500 text-white '
              : 'bg-none hover:bg-none bg-red-500 text-white'
          : ''
        }
        ${highlightCorrectAnswer && !clicked && questionAnswerPicked && answer.correct && isScoringQuiz
          ? 'bg-none hover:bg-none bg-green-500 text-white'
          : ''
        }
        ${isPredictionQuiz && clicked ? 'shadow-neu-inner font-bold' : 'font-normal'}
        normal-case
      `}
      onClick={handleClick}
      disabled={disabled}
    >
      <span className={disabled ? 'blur-sm  select-none' : ''}>{answer.title}</span>
    </Button>
  )
}

export default AnswerButton;
